import React from 'react'

const Licencias = () => {
  return (
    <div className='seccion'>
        <table className="mi-tabla">

            <caption> LICENCIAS </caption>

            <tr>
                <td> RAZONES PARTICULARES 👉 👉 👉 👉   </td>
                <a href='https://forms.gle/GqnkGpjba2CvBLM56' target="_blank" className="linksD" ><button>Click Aca</button></a>
            </tr>   
            
            <tr>
                <td> SOLICITUD DE LICENCIAS VARIAS 👉 👉 👉 👉  </td>
                <a href='https://forms.gle/kXAm1JQ72aV2orAB9' target="_blank" className="linksD" ><button>Click Aca</button></a>
            </tr>    
            
            <tr>
                <td> SUBIR CONSTANCIAS 👉 👉 👉 👉  </td>
                <a href='https://forms.gle/2MRknPRJJykKRhrW7' target="_blank" className="linksD" ><button>Click Aca</button></a>
            </tr>     

        </table>
    </div>
  ) 
}

export default Licencias